import { ReasonCode } from "@app/enum/ReasonCode";
import { RoadType } from "@app/enum/RoadType.enum";
import { VehicleType } from "@app/enum/VehicleType.enum";
import { GeofenceCategory } from "@app/interfaces/IGeofences";
import { AlcolockEventGroup } from "@app/main/components/tacho/alcolockCompliance/alcolock.enums";
import { TranslationService } from "@app/services/translation.service";
import { ReportParameterType } from "../../models/IReportParameters";

type ReportParameterMapping = {
    parameterType: ReportParameterType;
    values: { Name: string, Value: number }[];
}

export function reportParameterMappings(translationService: TranslationService): ReportParameterMapping[] {
    const mappings: ReportParameterMapping[] = [
        {
            parameterType: ReportParameterType.ShowOnlyAlcolockEventGroup,
            values: [
                { Name: "Any", Value: -1 },
                { Name: "Fail", Value: AlcolockEventGroup.Fail },
                { Name: "Circumvention", Value: AlcolockEventGroup.Circumvention },
                { Name: "Pass", Value: AlcolockEventGroup.Pass },
                { Name: "SignificantEvent", Value: AlcolockEventGroup.SignificantEvent }
            ]
        },
        {

            parameterType: ReportParameterType.ReasonCode,
            values: [
                { Name: translationService.t("Reports.Speeding"), Value: ReasonCode.ContextualSpeeding },
                { Name: translationService.t("Reports.HarshAcceleration"), Value: ReasonCode.HarshAcceleration },
                { Name: translationService.t("Reports.HarshCornering"), Value: ReasonCode.HarshCornering },
                { Name: translationService.t("Reports.HarshBraking"), Value: ReasonCode.HarshBraking },
                { Name: translationService.t("Reports.BadAnticipation"), Value: ReasonCode.BadAnticipation },
                { Name: translationService.t("Reports.Idling"), Value: ReasonCode.Idling }
            ]
        },
        {

            parameterType: ReportParameterType.GeofenceCategory,
            values: [
                { Name: translationService.tEnum(GeofenceCategory, "GeofenceCategory", GeofenceCategory.Standard), Value: GeofenceCategory.Standard },
                { Name: translationService.tEnum(GeofenceCategory, "GeofenceCategory", GeofenceCategory.Zone), Value: GeofenceCategory.Zone },
            ]
        },
        {

            parameterType: ReportParameterType.RoadType,
            values: [
                { Name: translationService.tEnum(RoadType, "RoadType", RoadType.Unknown), Value: RoadType.Unknown },
                { Name: translationService.tEnum(RoadType, "RoadType", RoadType.Motorway), Value: RoadType.Motorway },
                { Name: translationService.tEnum(RoadType, "RoadType", RoadType.DualCarriageway), Value: RoadType.DualCarriageway },
                { Name: translationService.tEnum(RoadType, "RoadType", RoadType.SingleCarriageway), Value: RoadType.SingleCarriageway },
                { Name: translationService.tEnum(RoadType, "RoadType", RoadType.BuiltUpArea), Value: RoadType.BuiltUpArea },
            ]
        },
        {

            parameterType: ReportParameterType.VehicleType,
            values: [
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Trailer), Value: VehicleType.Trailer },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Car), Value: VehicleType.Car },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.BusOrPSV), Value: VehicleType.BusOrPSV },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.HgvLessThan12T), Value: VehicleType.HgvLessThan12T },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Hgv12Tto22T), Value: VehicleType.Hgv12Tto22T },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.HgvGreaterThan22T), Value: VehicleType.HgvGreaterThan22T },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Lcv), Value: VehicleType.Lcv },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Motorcycle), Value: VehicleType.Motorcycle },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Unknown), Value: VehicleType.Unknown },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Asset), Value: VehicleType.Asset },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Plant), Value: VehicleType.Plant }
            ]
        },
        {
            parameterType: ReportParameterType.FilterVehicleRowsByVehicleType,
            values: [
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Trailer), Value: VehicleType.Trailer },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Car), Value: VehicleType.Car },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.BusOrPSV), Value: VehicleType.BusOrPSV },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.HgvLessThan12T), Value: VehicleType.HgvLessThan12T },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Hgv12Tto22T), Value: VehicleType.Hgv12Tto22T },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.HgvGreaterThan22T), Value: VehicleType.HgvGreaterThan22T },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Lcv), Value: VehicleType.Lcv },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Motorcycle), Value: VehicleType.Motorcycle },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Unknown), Value: VehicleType.Unknown },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Asset), Value: VehicleType.Asset },
                { Name: translationService.tEnum(VehicleType, "VehicleType", VehicleType.Plant), Value: VehicleType.Plant }
            ]
        }
    ];

    return mappings;
}
